import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogPayload, ConfirmDialogResponse } from '@fdm/shared';
import { Observable, of } from 'rxjs';
import { ReportFormStore } from './report-form.store';
import { ReportFormPage } from './report-form-control.service';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormValidationService {


  private forms: { [key: string]: FormGroup } = {};

  registerForm(key: string, form: FormGroup) {
    this.forms[key] = form;
  }

  isFormExists(key: string): boolean {
    return this.forms[key] !== undefined;
  }

  isFormValid(key: string): boolean {
    const form = this.forms[key];
    return form?.disabled || form?.valid ;
  }
  validateAllForms() {
    Object.values(this.forms).forEach(form => {
      form.markAllAsTouched();
      form.updateValueAndValidity();
    });
  }

  areAllFormsValid(): boolean {
    return Object.values(this.forms).every(form => form.disabled || form.valid);
  }
  getInvalidForms(): string[] {
    const invalid = Object.keys(this.forms).filter(key => {
      const form = this.forms[key];
      return !form.disabled && !form.valid;
    });
    return invalid;
  }
}
